import React from 'react'
import {Link}  from 'react-router-dom'
import Logo from '../../images/logo-2.svg'
import Projects from '../../api/project'



const Footer = (props) =>{

    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }

  return(
    <footer className={`wpo-site-footer ${props.ftClass}`}>
        <div className="wpo-upper-footer">
            <div className="container">
                <div className="row">
                    <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="widget about-widget">
                            <div className="logo widget-title">
                                <Link onClick={ClickHandler} className="logo" to="/"><img src={Logo} alt=""/></Link>
                            </div>
                            <p>Spécialistes en vente, achat, construction et rénovation de Riads à Marrakech.</p>
                            <ul>
                            <li>
                                <a onClick={ClickHandler} href="https://www.instagram.com/getriad/" target="_blank" rel="noopener noreferrer">
                                    <i className="ti-instagram"></i>
                                </a>
                                </li>
                                <li>
                                <a onClick={ClickHandler} href="https://www.facebook.com/profile.php?id=100083451698199" target="_blank" rel="noopener noreferrer">
                                    <i className="ti-facebook"></i>
                                </a>
                                </li>
                                {/* <li>
                                    <Link onClick={ClickHandler} to="/">
                                        <i className="ti-twitter-alt"></i>
                                    </Link>
                                </li>
                                <li>
                                    <Link onClick={ClickHandler} to="/">
                                        <i className="ti-google"></i>
                                    </Link>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="widget link-widget">
                            <div className="widget-title">
                                <h3>Nos Services</h3>
                            </div>
                            <ul>
                                <li><Link onClick={ClickHandler} to="/service-single/11">Vente et Achat de Riads</Link></li>
                                <li><Link onClick={ClickHandler} to="/service-single/12">Construction de Riads</Link></li>
                                <li><Link onClick={ClickHandler} to="/service-single/13">Rénovation et Restauration</Link></li>
                                {/* <li><Link onClick={ClickHandler} to="/service-single">Design d’Intérieur sur Mesure</Link></li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="widget wpo-service-link-widget">
                            <div className="widget-title">
                                <h3>Contact </h3>
                            </div>
                            <div className="contact-ft">
                                <ul>
                                    <li><i className="fi flaticon-location"></i>Marrakech, Medina En Face <br/> de Bab Agnaou N°: 30</li>
                                    <li><i className="fi flaticon-telephone"></i>+ (212) 06.69.91.48.63 <br/>
                                        + (212) 06.61.44.37.51</li>
                                    <li><i className="fi flaticon-email"></i>contact@getriad.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                        <div className="widget instagram">
                            <div className="widget-title">
                                <h3>Notre Gallery</h3>
                            </div>
                            <ul className="d-flex">
                                {Projects.slice(0, 6).map((project, pot) => (
                                    <li key={pot}> <img src={project.pImg} alt="" /> </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="wpo-lower-footer">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <ul>
                        <li>&copy; 2025 Get Riad. Tous les droits réservés. <span className="text-muted">|</span> <a href="https://agency.khedid.com" target="_blank" rel="noopener noreferrer">Développé par KH Agency</a></li>


                            <li><Link onClick={ClickHandler} to="/page/termes-d-utilisation">Termes et Conditions</Link> | <Link onClick={ClickHandler} to="/page/politique-de-confidentialite">Politique de Confidentialité</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>
  )
} 

export default Footer;